import { ConfirmDialog } from "@nymbl/nos2-rules";
import { formatDays } from "@/lib/team/metrics";
import { formatDateRange, type PtoRequestView } from "@/lib/team/pto-list";

/** Reject needs a reason (Vinyl's Reject PTO Request page; it is emailed to the requester). */
export function RejectPtoDialog({
  request,
  busy,
  onReject,
  onClose,
}: {
  request: PtoRequestView | null;
  /** The reject call is in flight: no second send, no dismiss mid-call. A 504 is not in flight. */
  busy: boolean;
  /** Resolves true when the reject succeeded, so the dialog closes only then. */
  onReject: (request: PtoRequestView, note: string) => Promise<boolean>;
  onClose: () => void;
}) {
  return (
    <ConfirmDialog
      open={request !== null}
      onOpenChange={(open) => !open && !busy && onClose()}
      title="Reject PTO request"
      description={
        request
          ? `${request.personName} · ${formatDateRange(request.startDate, request.endDate)} · ${formatDays(request.days)}`
          : ""
      }
      confirmLabel="Reject"
      variant="destructive"
      loading={busy}
      reason={{ label: "Reason", maxLength: 500 }}
      onConfirm={async (note) => {
        if (request && (await onReject(request, note))) onClose();
      }}
    />
  );
}
